"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HealingWaterAbilityHandler = exports.HealingWaterActorAbilityFactory = exports.HealingWaterAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const core_1 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
const Duration_1 = require("../../core/Duration");
const core_2 = require("../../core/effects/core");
class HealingWaterAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.HealingWater;
        this.__typeName = "HealingWater";
    }
}
exports.HealingWaterAbilityArgs = HealingWaterAbilityArgs;
let HealingWaterActorAbilityFactory = class HealingWaterActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("HealingWater", "OneAllies", 0);
    }
};
HealingWaterActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("HealingWater")
], HealingWaterActorAbilityFactory);
exports.HealingWaterActorAbilityFactory = HealingWaterActorAbilityFactory;
let HealingWaterAbilityHandler = class HealingWaterAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const [allyId] = ability.args.target.actorIds;
        container.applyAbilityAnimation({
            sequence,
            abilityKey: ability.args.__typeName,
            fallback: "casting",
            animatedId: ability.invokerId,
            onAnimated(sequence) {
                container.applyHealing({
                    sequence,
                    healerId: ability.invokerId,
                    targetId: allyId,
                    amount: container.getPercentOfBaseHealth(allyId, 30),
                    onApplied: sequence => {
                        sequence.pushSequence("sequential")
                            .push(new core_1.InstantVfxStepArgs(new LocationSelector_1.ActorVfxLocationSelector(allyId, "feet"), "GreenHealingPillar"));
                        container.applyBuff({
                            sequence,
                            creatorId: ability.invokerId,
                            targetId: allyId,
                            duration: Duration_1.Duration.Turns(4),
                            effect: new core_2.RegenerationEffectArgs("HealingWater", container.getPercentOfBaseHealth(allyId, 1))
                        });
                    }
                });
            }
        });
    }
};
HealingWaterAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.HealingWater)
], HealingWaterAbilityHandler);
exports.HealingWaterAbilityHandler = HealingWaterAbilityHandler;
